import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ spacing }) => ({
  cardRoot: {
    borderRadius: 0,
    boxShadow: 'none',
    height: '100%',
    overflow: 'visible'
  },
  cardContentRoot: {
    padding: 0
  },
  cardHeaderRoot: {
    paddingRight: spacing(3)
  },
  headerAvatarRoot: {
    padding: 0
  }
}));
